var map = {
	"./cover_1.jpg": 591,
	"./cover_10.jpg": 592,
	"./cover_11.jpg": 593,
	"./cover_12.jpg": 594,
	"./cover_13.jpg": 595,
	"./cover_14.jpg": 596,
	"./cover_15.jpg": 597,
	"./cover_16.jpg": 598,
	"./cover_17.jpg": 599,
	"./cover_18.jpg": 600,
	"./cover_19.jpg": 601,
	"./cover_2.jpg": 602,
	"./cover_20.jpg": 603,
	"./cover_21.jpg": 604,
	"./cover_22.jpg": 605,
	"./cover_23.jpg": 606,
	"./cover_24.jpg": 607,
	"./cover_3.jpg": 608,
	"./cover_4.jpg": 609,
	"./cover_5.jpg": 610,
	"./cover_6.jpg": 611,
	"./cover_7.jpg": 612,
	"./cover_8.jpg": 613,
	"./cover_9.jpg": 614
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 164;



/*****************
 ** WEBPACK FOOTER
 ** ./src/images/covers ^\.\/cover_.*\.jpg$
 ** module id = 164
 ** module chunks = 0
 **/